import { connect } from 'redux-bundler-react';
import LinkButton from '@components/link/linkButton';
import { FileTypes, ResourceFiles } from '@src/utils/enums';
import ExternalLink from '@src/app-components/external-link/ExternalLink';

const JurisdictionScientificMethods = connect('doDownloadFile', ({ doDownloadFile }) => (
  <>
    <p className='text-bold'>
      <ExternalLink
        href='https://www.usace.army.mil/Missions/Civil-Works/Regulatory-Program-and-Permits/reg_supp/'
        title='Wetland Delineation Manual and Regional Supplements'
        content='Wetland Delineation Manual and Regional Supplements'
      />
    </p>
    <p>
      Wetland delineation consists of standardized procedures that are used to determine if a wetland is present on a
      site and, if so, to establish its boundaries in the field.
    </p>
    <p className='text-bold'>
      <ExternalLink
        href='https://www.usace.army.mil/Missions/Civil-Works/Regulatory-Program-and-Permits/reg_supp/#data-sheets'
        title='Automated Wetland Determination Data Sheet (ADS)'
        content='Automated Wetland Determination Data Sheet (ADS)'
      />
    </p>
    <p>
      The Microsoft Excel-based ADS increases technical accuracy by reducing errors and increases efficiency by
      automatically populating many of the field indicators of wetland hydrology, hydrophytic vegetation, and hydric
      soils. These should be used to the extent possible instead of paper datasheets forms.
    </p>
    <p className='text-bold'>
      <ExternalLink
        href='https://www.erdc.usace.army.mil/Media/Fact-Sheets/Fact-Sheet-Article-View/Article/486085/ordinary-high-water-mark-ohwm-research-development-and-training/'
        title='Ordinary High Water Mark (OHWM) Guidance  and Manual'
        content='Ordinary High Water Mark (OHWM) Guidance and Manual'
      />
    </p>
    <p>The OHWM defines the lateral limits of non-tidal open waters including streams, rivers, lakes, ponds, etc.</p>
    <p className='text-bold'>
      <ExternalLink
        href='https://wetland-plants.sec.usace.army.mil/'
        title='National Wetland Plant List (NWPL)'
        content='National Wetland Plant List (NWPL)'
      />
    </p>
    <p>
      The NWPL, along with its wetland plant species status, plays a crucial role in wetland delineation, wetland
      restoration and research. Additionally, it serves as a valuable resource for general botanical information about
      wetland plants. The NWPL encompasses all 50 U.S. states, the District of Columbia, and the U.S. territories.
      Furthermore, to enhance understanding of plant distribution, the NWPL includes a complete geographic range for
      each taxon across North America north of Mexico. The wetland plant data is categorized into ten regions that align
      with the wetland delineation regions established by the U.S. Army Corps of Engineers.
    </p>
    <p className='text-bold'>
      <LinkButton
        onClick={() => doDownloadFile(ResourceFiles.ARDRRecommendedMinimumStandards, FileTypes.Resource, null)}
        title='Recommended Minimum Standards for Aquatic Resource Delineation Reports (ARDR) [PDF, 42 pages]'
        aria-label='Download Recommended Minimum Standards for Aquatic Resource Delineation Reports (ARDR)'
      >
        Recommended Minimum Standards for Aquatic Resource Delineation Reports (ARDR) [PDF, 42 pages]
      </LinkButton>
    </p>
    <p>
      This document outlines recommended minimum standards for documenting aquatic resource delineations in an ARDR. It
      includes an attached "Aquatic Resource Delineation Report Template" to help standardize report format.
    </p>
    <p className='text-bold'>
      <LinkButton
        onClick={() => doDownloadFile(ResourceFiles.GNSSGuide, FileTypes.Resource, null)}
        title='Guide for Recording Aquatic Resource Delineations Using Global Navigation Satellite Systems (GNSS) [PDF, 8 pages]'
        aria-label='Download Guide for Recording Aquatic Resource Delineations Using Global Navigation Satellite Systems (GNSS)'
      >
        Guide for Recording Aquatic Resource Delineations Using Global Navigation Satellite Systems (GNSS) [PDF, 8
        pages]
      </LinkButton>
    </p>
    <p>
      This guide provides recommendations for using high-accuracy GNSS receivers and GIS to electronically map aquatic
      resource boundaries. Consistent application of these guidelines supports accurate data collection, quantification
      of aquatic resource extent, and spatial assessment of proposed project impacts. Please note, aquatic resources can
      be provided bulk upload CSV or geodatabase (GDB) templates available within the request.
    </p>
    <p className='text-bold'>
      <LinkButton
        onClick={() => doDownloadFile(ResourceFiles.ARDRFigureExample, FileTypes.Resource, null)}
        title='Aquatic Resource Delineation Report Figure Example [PPKX, 12.3 MB]'
        aria-label='Download Aquatic Resource Delineation Report Figure Example'
      >
        Aquatic Resource Delineation Report Figure Example [PPKX, 12.3 MB]
      </LinkButton>
    </p>
    <p>
      This ArcGIS Pro Project file was used to create the ARDR guide figures and provides an example format for aquatic
      resource mapping figures provided with a delineation report submission.
    </p>
  </>
));

export default JurisdictionScientificMethods;
